import * as React from "react";

import * as brace from 'brace';
import AceEditor from 'react-ace';
import 'brace/ext/language_tools';
import 'brace/mode/java';
import 'brace/mode/scala';
import 'brace/mode/javascript';
import 'brace/mode/python';

import 'brace/theme/solarized_dark';

// Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown, faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons'
library.add(faAngleDoubleDown, faAngleDoubleUp)

export const __brace = brace;

interface IEditorToolbar { };
function EditorToolbar(props: IEditorToolbar) {
    return (
        <div className="CodeEditor__toolbar">
            <span role="button" className="CodeEditor__toolbar--btn">
                <i className="fas fa-play" />
                <span>RUN CODE</span>
            </span>
            <span role="button" className="CodeEditor__toolbar--btn">
                <i className="fas fa-stop"></i>
                <span>STOP</span>
            </span>
            <span role="button" className="CodeEditor__toolbar--btn">
                <i className="fas fa-redo"></i>
                <span>RESET</span>
            </span>
            <span role="button" className="CodeEditor__toolbar--btn">
                <i className="fas fa-question"></i>
                <span>SHOW HINT</span>
            </span>
        </div>
    )
}

interface IEditorConsole { results: string, isOpen: boolean, onToggle(): void };
function EditorConsole(props: IEditorConsole) {
    function getArrow(isOpen: boolean) {
        if (isOpen) {
            return <FontAwesomeIcon icon="angle-up" />
        } else {
            return <FontAwesomeIcon icon="angle-down"/>
        }
    }
    return (
        <div className="CodeEditor__console">
            {
                props.isOpen &&
                <div>
                    <pre>
                        {props.results}
                    </pre>
                </div>
            }

            <span role="button" className="CodeEditor__console--collapse" onClick={props.onToggle}>
                {
                    getArrow(props.isOpen)
                }
            </span>
        </div>
    )
}

interface ICodeEditor {
    language: string
}
class CodeEditor extends React.Component<ICodeEditor, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isOpenConsole: false,
        };

    }

    public onChange = (value: string) => {
        console.log(value);
    }

    public onToggleConsole = () => {
        this.setState({
            isOpenConsole: !this.state.isOpenConsole
        })
    }

    public render() {
        return (
            <div className="CodeEditor">
                <AceEditor
                    width="100%"
                    height="100px"
                    mode={this.props.language}
                    theme="solarized_dark"
                    onChange={this.onChange}
                    fontSize={16}
                    setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        enableSnippets: true,
                        showLineNumbers: true,
                        tabSize: 2,
                        readOnly: false
                    }}
                />
                <EditorToolbar />
                <EditorConsole results="Hello world" onToggle={this.onToggleConsole} isOpen={this.state.isOpenConsole} />
            </div>
        )
    }
}

export default CodeEditor;


// WEBPACK FOOTER //
// ./src/components/editor/CodeEditor.tsx